import "./ProcessPlanning.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Process from "./sections/Process";
import Planning from "./sections/Planning";
import CostGuide from "./sections/CostGuide";
import Faq from "./sections/Faq";
import StartPlanning from "./sections/StartPlanning";
import Footer from "@/reusable_sections/Footer";
export default function ProcessPlanningPage() {
  return <div>
      <Header />
      <Hero />
      <Process />
      <Planning />
      <CostGuide />
      <Faq />
      <StartPlanning />
      <Footer />
    </div>;
}